// ════════════════════════════════════════════════════════════════
// FREE TIER LIMITS — Enforces freemium boundaries
// ════════════════════════════════════════════════════════════════

import { useLicenseStore } from '../stores/licenseStore';

export const FREE_LIMITS = {
  maxCollections: 2,
  maxItemsPerCollection: 5,
  maxIdentifiersPerItem: 5,
  maxLedgerEntries: 20,
} as const;

export function isPro(): boolean {
  return useLicenseStore.getState().isPro;
}

export function canAddCollection(currentCount: number): boolean {
  return isPro() || currentCount < FREE_LIMITS.maxCollections;
}

export function canAddItem(currentCount: number): boolean {
  return isPro() || currentCount < FREE_LIMITS.maxItemsPerCollection;
}

export function canAddIdentifier(currentCount: number): boolean {
  return isPro() || currentCount < FREE_LIMITS.maxIdentifiersPerItem;
}

export function getRemainingCollections(currentCount: number): number {
  if (isPro()) return Infinity;
  return Math.max(0, FREE_LIMITS.maxCollections - currentCount);
}

export function getRemainingItems(currentCount: number): number {
  if (isPro()) return Infinity;
  return Math.max(0, FREE_LIMITS.maxItemsPerCollection - currentCount);
}
